import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// Discreet exit-intent bar for GARAGE OWNERS. Fires once/session when a desktop
// visitor moves to leave (cursor to the top edge). Never on owner/checkout/admin
// routes, never on mobile (no reliable exit signal), respects a session dismiss.
const SKIP = ["/my-garage", "/dashboard", "/checkout", "/admin", "/auth", "/login", "/register"];

export default function ExitIntentBar() {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.innerWidth < 900) return; // desktop only
    const p = location.pathname;
    if (SKIP.some((s) => p === s || p.startsWith(s + "/"))) return;
    try { if (sessionStorage.getItem("vroum_exit_shown")) return; } catch {}

    const onLeave = (e) => {
      if (e.clientY <= 0) {
        setShow(true);
        try { sessionStorage.setItem("vroum_exit_shown", "1"); } catch {}
        document.removeEventListener("mouseout", onLeave);
      }
    };
    const t = setTimeout(() => document.addEventListener("mouseout", onLeave), 4000);
    return () => { clearTimeout(t); document.removeEventListener("mouseout", onLeave); };
  }, [location.pathname]);

  if (!show) return null;
  return (
    <div className="vexit" role="dialog" aria-label="Για συνεργεία">
      <style>{`
        .vexit{position:fixed;left:0;right:0;bottom:0;z-index:1400;display:flex;align-items:center;gap:16px;
          padding:14px 22px;background:linear-gradient(90deg,#12151c,#0f1219);border-top:1px solid rgba(255,106,31,.35);
          box-shadow:0 -12px 30px -12px rgba(0,0,0,.6);animation:vexitup .4s cubic-bezier(.2,.7,.2,1);
          font-family:"SF Pro Text",-apple-system,system-ui,sans-serif}
        @keyframes vexitup{from{transform:translateY(100%)}to{transform:translateY(0)}}
        .vexit b{color:#fff;font-size:15px}
        .vexit span{color:#aab4c2;font-size:13.5px}
        .vexit .sp{flex:1}
        .vexit a{background:linear-gradient(135deg,#ff6a1f,#e0560c);color:#fff;font-weight:800;font-size:14px;
          padding:11px 20px;border-radius:10px;text-decoration:none;white-space:nowrap}
        .vexit button{background:none;border:0;color:#8a93a3;font-size:20px;cursor:pointer;line-height:1;padding:4px}
        @media(max-width:640px){.vexit span{display:none}}
      `}</style>
      <div>
        <b>Είσαι συνεργείο;</b> <span>Το προφίλ σου είναι ήδη στο VROUM — διεκδίκησέ το δωρεάν & δες πόσοι οδηγοί σε ψάχνουν.</span>
      </div>
      <div className="sp" />
      <Link to="/pricing" onClick={() => setShow(false)}>Γίνε #1 δωρεάν →</Link>
      <button onClick={() => setShow(false)} aria-label="Κλείσιμο">×</button>
    </div>
  );
}
